import deepmerge from 'deepmerge';

import { ThemeColors } from '../../../../tokens/colors/types';
import { BaseDeprecatedColors } from '../../../types';
import derivedED from './ED';

const uniqueBackground = '#66C431';
const uniqueForeground = '#2D7D00';

export default (baseColors: ThemeColors): BaseDeprecatedColors => {
  return {
    ...deepmerge(derivedED(baseColors), {
      deprecatedAppBannerColors: '#F5F5F5',
      appBanner: {
        bt: baseColors.primary['50'],
        image: '/images/onefront/bluestone/GV/govoyages_app_background.png',
        uniqueBackground,
        uniqueForeground,
      },
      promotional: {
        primary: {
          default: baseColors.primary['90'],
          dark: '#0B1F00',
        },
        secondary: {
          default: baseColors.primary['30'],
          dark: baseColors.primary['70'],
        },
      },
    }),
    banner: {
      bg: baseColors.primary['90'],
      fg: baseColors.secondary['50'],
      gradient: [baseColors.primary['90'], '#0B1F00'],
    },
  };
};
